@if (isLoadingData()) {
  <div class="laurels-skeleton">
    <ush-movie-detail-skeleton width="8rem" height="1.5rem"></ush-movie-detail-skeleton>
    <div class="laurels-skeleton__items">
      @for (item of [1, 2, 3]; track item) {
        <ush-movie-detail-skeleton width="100%" height="8rem" radius="18px"></ush-movie-detail-skeleton>
      }
    </div>
  </div>
} @else if (isBrowser) {
  <h1
    class="laurels-header header-msg title"
    i18n-attr="@@public.commons.laurels"
    data-translate="public.commons.laurels"
    i18n="@@public.commons.laurels"
  >
    Laurels
  </h1>

  <div class="laurels-carousel-wrapper">
    <div
      part="button-prev"
      class="swiper-button-prev"
      tabindex="0"
      role="button"
      aria-label="Previous slide"
      aria-controls="swiper-wrapper-61441813ac57da6a"
    >
      <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z"
          fill="currentColor"
          transform-origin="center"
          transform="rotate(180)"
        ></path>
      </svg>
    </div>

    <swiper-container ushSwiperElement [config]="swiperConfig" init="false">
      <swiper-slide *ngFor="let laurel of laurels()">
        <ush-ui-movie-laurel [laurel]="laurel"></ush-ui-movie-laurel>
      </swiper-slide>
    </swiper-container>

    <div
      part="button-next"
      class="swiper-button-next"
      tabindex="0"
      role="button"
      aria-label="Next slide"
      aria-controls="swiper-wrapper-4106a1ed2c27a76b5"
    >
      <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z"
          fill="currentColor"
        ></path>
      </svg>
    </div>
  </div>
}
